/* Collection card v3 — finish swatches.
 *
 * Deliberately its own file and its own selectors rather than an extension
 * of theme-collection-item-v2.js: while the A/B test runs, both cards are
 * live in the same theme and a shared handler is one selector typo away
 * from breaking the control.
 *
 * Delegated from the document so it also covers cards that arrive after
 * load (filter and sort re-render the grid).
 */
document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.collectionItemV3Swatch');
    if (!swatch) return;

    event.preventDefault();
    if (swatch.classList.contains('active')) return;

    const card = swatch.closest('.collectionItemV3');
    if (!card) return;

    card.querySelector('.collectionItemV3Swatch.active')?.classList.remove('active');
    swatch.classList.add('active');

    const colour = swatch.dataset.color;
    card.querySelector('.collectionItemV3VisualImage.active')?.classList.remove('active');
    card.querySelector(`.collectionItemV3VisualImage[data-color="${colour}"]`)?.classList.add('active');
});
